import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { useLenis } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ClientGallery from "@/pages/Gallery";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  useLenis();
  return (
    <div className="grain bg-[#0A0A0A] min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<ClientGallery />} />
            <Route path="/gallery/:token" element={<ClientGallery />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", border: "1px solid rgba(255,255,255,0.1)", color: "#F5F4F0" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
